import { render, staticRenderFns } from "./createPackageOrder.vue?vue&type=template&id=315e0b5e&scoped=true"
import script from "./createPackageOrder.vue?vue&type=script&lang=js"
export * from "./createPackageOrder.vue?vue&type=script&lang=js"
import style0 from "./createPackageOrder.vue?vue&type=style&index=0&id=315e0b5e&prod&scoped=true&lang=css"
import style1 from "./createPackageOrder.vue?vue&type=style&index=1&id=315e0b5e&prod&lang=css"
import style2 from "./createPackageOrder.vue?vue&type=style&index=2&id=315e0b5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "315e0b5e",
  null
  
)

export default component.exports